var Model = Model || {};

(function(global) {

  'use strict';

  //global
  var $window = $(window);
  var $body = $('body');

  var windowAttr = {
    width: global.innerWidth,
    height: global.innerHeight,
    top: global.pageYOffset
  };

  //breakpoint
  var base_w = 768;

  //header
  var $headNav = $('#siteHeader');

  var headAttr = {
    height : 0,
  }
  var $headerSpBtnTxt = $('.l-header-func_btn-txt');
  
  var $headInner = $('.l-header-wrap');
  var headInnerAttr = {
    height : 0,
  }
  //var fixHeaderHeight = 0;

  //gnav
  var $gnav = $('#globalNav');
  //gnav height
  var gnavAttr = {
    height: 0,
    position: 0,
  }
  //gnav click area
  var $clickArea = $('#navBtn,#globalNav a[href*="#"],#overlay');
  
  //active fg
  var _openFg = false;
  
  var _padding = '0px';
  //gnav sp inner list
  var $gnavSp = $('#spNav .list-parent');
  //gnav sp inner list activeflg
  var spNavFg = [];
  for(var i = 0,max = $gnavSp.length; i < max; i++)
  {
    spNavFg[i] = false;
  }

  //mainvisual
  var $mv = $('#mainvisual');
  var $mainvisual = $('#mainvisual .slider');
  var $mvChild = $('#mainvisual .pc-visible');

  //maincontents
  var $main = $('#mainContents');

  //mh
  var $jsMh = $('.js-mh');

  //scroll
  var scrollpos;
  
  Model.METHODS = {
    init: function()
    {
      //header height set
      headAttr = {
        height : $headNav.outerHeight(),
      }
      //headinner
      headInnerAttr = {
        height : $headInner.outerHeight(),
      }
      //gnav position height set
      gnavAttr = {
        height: $gnav.outerHeight(),
        position: $gnav.offset().top,
      }
      //window size reget
      windowAttr = {
        width: global.innerWidth,
        height: global.innerHeight,
        top: global.pageYOffset
      };
      this.indexMvAdjust();
      this.lib();
      this.pageScroll();
      //this.headerAdjust();
      //this.fadeInup();
      this.tab();
      this.gmenu();
      this.accordion();
      this.mh();
      this.loading();
      this.recruit();
    },
    //plugin
    lib: function()
    { 
      if($mainvisual.get(0))
      {
        $mainvisual.slick({
          autoplay: true,
          autoplaySpeed: 3000,
          speed: 1000,
          dots: true,
          arrows: true,
          appendArrows: $('#mainvisual .l-mainvisual-arrowbox'),
          prevArrow: '<a class="prev"></a>',
          nextArrow: '<a class="next"></a>',
          slidesToShow: 1,
          centerMode: true,
          variableWidth: true,
          centerPadding: 0,
        });
      };
    },
    mh : function()
    {
      if(windowAttr.width > 1000){
        if($jsMh.get(0))
        {
          $jsMh.each(function() {
            var $this = $(this);
            var arrayMhTarget = $this.data('mh-target').split(' ');
            for (var i = 0; i < arrayMhTarget.length; i++) {
              $this.find(arrayMhTarget[i]).matchHeight({byRow:false});
            }
          });
        }
      }else{
        if($jsMh.get(0))
        {
          $jsMh.each(function() {
            var $this = $(this);
            var arrayMhTarget = $this.data('mh-target').split(' ');
            for (var i = 0; i < arrayMhTarget.length; i++) {
              $this.find(arrayMhTarget[i]).matchHeight({remove:true});
            }
          });
        }
      }
    },
    //fixednav
    fixedNav: function(){
      if(windowAttr.width > 1200){
        var value = $window.scrollTop();
        var triger = headInnerAttr.height;
        if ( value > triger) {
          $gnav.addClass('is-fixed');
          $main.css('margin-top', gnavAttr.height);
        } else {
          $gnav.removeClass('is-fixed');
          $main.css('margin-top', '0');
        }
      }else{
        $main.css('margin-top', '');
      }
    },
    //gnav
    gmenu: function()
    {
      //$('html').removeclass('scroll-prevent');
      $gnavSp.on(
        'click',
        function () 
        {
          var $this = $(this);

          var _idx = $gnavSp.index($this);
          
          if(spNavFg[_idx]){
            $this.removeClass('is-open');          
          }else{
            $this.addClass('is-open');
          }
          
          spNavFg[_idx] = (spNavFg[_idx])?false:true;
        }
      );
      $clickArea.on(
        'click', 
        function() 
        {

          _openFg = (_openFg)?false:true;
          _padding = (_openFg)?'50px':'0px';

          if (windowAttr.width <= base_w) {
            $gnav.css({ 'padding-bottom': _padding });
          }

          if(_openFg == false){
            $headNav.removeClass('is-open');
            $headerSpBtnTxt.html('メニュー');
            $body.removeClass('scroll-prevent').css({'top': 0});
            window.scrollTo( 0 , scrollpos );
          }else{
            $headNav.addClass('is-open');
            $headerSpBtnTxt.html('閉じる');
            scrollpos = $(window).scrollTop();
            $body.addClass('scroll-prevent').css({'top': -scrollpos});
          }
          
        }
      );
    },
    //スクロール
    /**
     * アンカーリンク
     */
    pageScroll: function()
    {
      //document
      var $dom = $('body,html');
      //urlハッシュ
      var _urlHash = location.hash;
      //スクロールスピード
      var _speed = 500;
      //select
      var $target;
      //スクロール位置
      var _position = 0;
      
      var _scroll = function()
      {

        _position = $target.offset().top - 70;

        $dom.stop().animate(
          {
            scrollTop:_position
          }, 
          _speed, 
          "swing"
          );

          return false;

      };
      //ページ移動
      if(_urlHash != '')
      {
        //select生成
        $target = $(_urlHash);
        //あれば
        if($target.get(0))
        {

          //スクロールを0に戻す
          $dom.stop().scrollTop(0);

          setTimeout(
            function()
            {

              _scroll();

            },
            500
          );

        };

      };
      //a click
      $('a[href^="#"]').on(
        'click',
        function(e)
        {

          e.preventDefault();
          //href属性取得
          var __href = $(this).attr('href');
          //select 生成
          $target = $(__href == '#' || __href == '' ? 'html' : __href);

          _scroll();

        }
      );

    },
    //メインビジュアルセット
    indexMvAdjust : function()
    {
      var _windowH = (windowAttr.height < 800)?1000:windowAttr.height;
      var _mvCss = {};
      if($mv.get(0))
      {
        if(windowAttr.width > base_w){
          _mvCss = {
            'height' : _windowH - headAttr.height
          };
        }else{
          _mvCss = {
          'height' : ''
          };
        }
        $mv.css(_mvCss);
        $mvChild.css(_mvCss);
      }
    },
    // headerAdjust: function(){
    //   var _contentCss = {
    //     'marginTop' : fixHeaderHeight,
    //   };
    //   $('#contents').css(_contentCss);
    // },
    // fadeInup : function(){
    //   $('.fadeInUp').each(function() {
    //     var t = $(this).offset().top,
    //         e = $(window).scrollTop();
    //     t - $(window).height() + 100 < e && ($(this).css('opacity', '1'), $(this).css('transform', 'translateY(0)'), $(this).addClass('is-move'))
    //   })
    // },
    tab : function(){
      if($('.c-tab').get(0))
      {
        var $tabBtn = $('.c-tab-wrap .c-tab-ope');
        var $tabWrap = $('.c-tab-wrap');
        $tabBtn.on(
          'click',
          function()
          {

          var $this = $(this);
          
          var $tab_wrap = $this.parents('.c-tab-wrap').first();
          
          var $tabw = $tab_wrap.data('tabw');
          
          var $dtab = $this.data('dtab');
          
          $tab_wrap.find('.c-tab-ope').removeClass('is-selected');
          
          $this.addClass('is-selected');
          
          $('#'+$tabw).find('.c-tab-contents-inner').removeClass('is-active');
          
          $('#'+$tabw).find('.c-tab-contents-inner.'+$dtab).addClass('is-active');
        }
        );

        for(var i = 0,max = $tabWrap.length; i< max; i++)
          {
            var $tab_first = $tabWrap.eq(i).data('firstopen');
            if($tab_first){
              $tabWrap.eq(i).find($tab_first).click();
            }else{
              $tabWrap.eq(i).find('.c-tab-ope').first().click();
            }
            
          };
      }
    },
    accordion : function(){
      var $acBtn = $('.js-ac_btn');
      var $acContent = $('.js-ac_content');

      $acBtn.on(
      'click',
      function()
      {

      var $this = $(this);

      var _idx = $acBtn.index($this);
      $this.toggleClass('is-active');
      $acContent.eq(_idx).slideToggle(200);

      }
      );
    },
    loading : function(){
      $('#loader .loader').fadeOut(1000, function(){
        $('#loader').fadeOut(800);
      });
    },
    recruit : function(){
      $('.js-p-entry-forms-form-select').on('change', function(e) {
        var key = $(this).val();
        var job = $(this).find(':selected').text();
        $('input[name="希望職種"]').val(job);
      });
    }
  };
  $window.on('load',function(){
    Model.METHODS.init();
  });
  $(window).resize(function() {
    windowAttr = {
      width : global.innerWidth,
      height : global.innerHeight,
    };
    headAttr = {
      height : $headNav.outerHeight(),
    }
    Model.METHODS.indexMvAdjust();
    if(windowAttr.window <= 1200){
      Model.METHODS.gmenu();
    }
    Model.METHODS.mh();
    //Model.METHODS.headerAdjust();
  });
  $window.on('scroll',function(){
    windowAttr.top = global.pageYOffset;
    //Model.METHODS.fadeInup();
    Model.METHODS.fixedNav();
  });
})(this);

